import React from "react"
import { Scrollbars } from "react-custom-scrollbars"
import PurchaseCard from "../../components/PurchaseCard"
import moment from "moment-timezone"

export const EtrInsightsCalendarEventInfo = ({ className = "", model }) => {
  const {
    renderEventNav,
    renderPurchaseCards,
    eventTime,
    eventDate,
    event,
    events,
    eventLocation,
    Speakers,
    Organization,
    eventSignupUri,
    onSignUp,
  } = model

  const eventTimeZone = "America/New_York"
  const parsedTimeEastern = moment.tz(eventTime, "h:mm A", eventTimeZone)
  const eventStartEastern = moment
    .tz(eventDate, eventTimeZone)
    .startOf("day")
    .add(parsedTimeEastern.hour(), "hours")
    .add(parsedTimeEastern.minute(), "minutes")

  const localNow = moment()
  const isPastEvent = localNow.isAfter(eventStartEastern)

  return (
    <div className={[className, "event-details-wrap"].join(" ")}>
      <div className="event-details-header">
        <div className="header col-right">
          <span>Event Info</span>
        </div>
        {renderEventNav(events)}
      </div>
      <div className="event-list">
        <div className="event-list-inner">
          <div key={event.name} className="scroll">
            <Scrollbars
              autoHide={false}
              autoHeightMin={400}
              autoHeight
              style={{ width: "100%" }}
            >
              <ul className="event-details">
                <li>
                  <span>{event.name}</span>
                </li>
                <li>
                  <span>
                    <strong>{moment.utc(eventDate).format("MMMM D")}</strong> -{" "}
                    {moment(eventTime, "hh:mmA").format("h:mm A [(EST)]")}
                  </span>
                </li>
                <li>
                  <strong>{Speakers[0]["Speaker Name"]}</strong> -{" "}
                  {Speakers[0]["Speaker Title"]}
                </li>
                {Organization && (
                  <li>
                    <strong>{Organization}</strong>
                  </li>
                )}
                <li>
                  <span>{eventLocation}</span>
                </li>
                <li>
                  <p>{event.description}</p>
                </li>
              </ul>
            </Scrollbars>
            <div className="product-links">
              {eventSignupUri && !isPastEvent && (
                <div className={"etr-insights-details-buttons-container"}>
                  <PurchaseCard
                    buttonText="REGISTER TO ATTEND"
                    buttonClasses={["btn", "btn-light", "btn-outline"]}
                    buttonAction={onSignUp}
                    data-cy={"event-signup-register-button"}
                  />
                </div>
              )}
              {renderPurchaseCards(event)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
